module.exports = __webpack_public_path__ + "assets/img/team_bg.b2e22e0a.png";